import React, { useState, useEffect } from "react";
import { useTheme } from "../components/ThemeContext";
import {
  Button,
  Row,
  Col,
  Dropdown,
  DropdownButton,
  FormControl,
  Modal,
  Pagination,
} from "react-bootstrap";
import "../App.css";
import NavMenu from "../components/NavMenu";
import axios from "axios";
import TextareaAutosize from "react-textarea-autosize";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";
import moment from "moment";

function AppraisalAssessment() {
  const [step, setStep] = useState(1);
  const [selectedValue, setSelectedValue] = useState("Select staff");
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [staff, setStaff] = useState([]);
  // const [supervisorid, setSupervisorID] = useState("");
  const [roles, setRoles] = useState([]);
  const [evaluationType, setEvaluationType] = useState("appraisal");
  const [searchTerm, setSearchTerm] = useState("");
  const [showStaffDropdown, setShowStaffDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [template, setTemplate] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [saving, setSaving] = useState(false);
  const [deletingItemId, setDeletingItemId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil((template?.length || 0) / itemsPerPage);
  const paginatedData = template
    ? template.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
      )
    : [];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();
  const { isDark } = useTheme();

  const location = useLocation();
  const staff_id = location.state?.staff_id;

  useEffect(() => {
    // Only auto-load default template when creating a new PA form.
    // In edit mode, data must come from HR.manage_appraisal with manage_id.
    // If this runs during edit mode, existing rows lose their id and save will insert duplicates.
    if (!editMode && selectedRole?.role_id) {
      fetchDetailTemplate(selectedRole.role_id);
    }
  }, [selectedRole, editMode]);

  const [factors, setFactors] = useState([
    { factor: "", description: "", rating: "5" },
    { factor: "", description: "", rating: "5" },
    { factor: "", description: "", rating: "5" },
  ]);

  const [performances, setPerformances] = useState([
    { description: "", rating: "5", score: 1 },
    { description: "", rating: "5", score: 1 },
    { description: "", rating: "5", score: 1 },
  ]);

  const handleSelectStaff = (eventKey) => {
    const selected = staff.find((s) => String(s.staff_id) === eventKey);
    setSelectedStaff(selected);
    setSelectedValue(selected?.display_name || "Select staff");
    setShowStaffDropdown(false);
    setSearchTerm("");
  };

  const filteredStaff = staff.filter((s) =>
    s.display_name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSelectRole = (eventKey) => {
    const role = roles.find(
      (role) => String(role.role_id) === String(eventKey),
    );

    if (editMode) {
      setEditMode(false);
      setEditingTemplate(null);
    }

    setSelectedRole(role);
  };

  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   if (user?.description) {
  //     setSupervisorID(user.id);
  //   }
  // }, []);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API}/getStaffName`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data.success) {
          setStaff(response.data.data);
        } else {
          console.error(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching staff data:", error);
      }
    };

    fetchStaff();
  }, []);

  useEffect(() => {
    if (staff.length > 0 && staff_id) {
      const selectedStaff = staff.find(
        (s) => String(s.staff_id) === String(staff_id),
      );
      if (selectedStaff) {
        setSelectedValue(selectedStaff.display_name);
      }
    }
  }, [staff, staff_id]);

  const fetchDetailTemplate = async (roleId) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API}/getDetailTemplate`,
        {
          params: { role_id: roleId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        const data = response.data.data;

        const factorItems = data.filter((item) => item.factor !== null);

        setFactors(
          factorItems.map((item) => ({
            factor: item.factor || "",
            description: item.description || "",
            rating: item.default_rating_scale || "",
          })),
        );
      } else {
        console.error("Error fetching template detail:", response.data.message);
      }
    } catch (error) {
      console.error("Error loading detail template:", error);
    }
  };

  const addFactor = () => {
    setFactors([...factors, { factor: "", description: "", rating: "5" }]);
  };

  const addPerformance = () => {
    setPerformances([
      ...performances,
      { description: "", rating: "5", score: 1 },
    ]);
  };

  const handleFactorChange = (index, field, value) => {
    const updated = [...factors];
    updated[index][field] = value;
    setFactors(updated);
  };

  const handlePerformanceChange = (index, field, value) => {
    const updated = [...performances];
    updated[index][field] = value;
    setPerformances(updated);
  };

  const deleteManageAppraisalItem = async (itemId) => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("No auth token found in localStorage");
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API}/deleteManageAppraisalItem`,
      {
        manage_id: itemId,
        staff_id: selectedStaff?.staff_id,
        role_id: selectedRole?.role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  };

  const handleDeleteFactorRow = async (index) => {
    const item = factors[index];
    const itemId = item?.id || item?.manage_id;

    if (factors.length <= 1) {
      alert("At least one factor is required.");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this factor?")) {
      return;
    }

    try {
      if (itemId) {
        setDeletingItemId(itemId);
        const result = await deleteManageAppraisalItem(itemId);

        if (!result.success) {
          alert(result.message || "Failed to delete factor.");
          return;
        }
      }

      setFactors((prev) => prev.filter((_, i) => i !== index));
    } catch (error) {
      console.error("Error deleting factor:", error);
      alert(
        error.response?.data?.message ||
          "Server error. Please try again later.",
      );
    } finally {
      setDeletingItemId(null);
    }
  };

  const handleDeletePerformanceRow = async (index) => {
    const item = performances[index];
    const itemId = item?.id || item?.manage_id;

    if (performances.length <= 1) {
      alert("At least one objective is required.");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this objective?")) {
      return;
    }

    try {
      if (itemId) {
        setDeletingItemId(itemId);
        const result = await deleteManageAppraisalItem(itemId);

        if (!result.success) {
          alert(result.message || "Failed to delete objective.");
          return;
        }
      }

      setPerformances((prev) => prev.filter((_, i) => i !== index));
    } catch (error) {
      console.error("Error deleting objective:", error);
      alert(
        error.response?.data?.message ||
          "Server error. Please try again later.",
      );
    } finally {
      setDeletingItemId(null);
    }
  };

  useEffect(() => {
    const fetchRoles = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      try {
        const response = await axios.get(
          process.env.REACT_APP_API + `/getRoles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.success) {
          setRoles(response.data.data);
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (err) {
        console.error("Failed to fetch tags:", err);
      }
    };

    fetchRoles();
  }, []);

  const resetForm = () => {
    setStep(1);
    setEditMode(false);
    setEditingTemplate(null);
    setEvaluationType("appraisal");
    setSelectedStaff(null);
    setSelectedRole(null);
    setSelectedValue("Select staff");

    setFactors([
      { factor: "", description: "", rating: "5" },
      { factor: "", description: "", rating: "5" },
      { factor: "", description: "", rating: "5" },
    ]);

    setPerformances([
      { description: "", rating: "5", score: 1 },
      { description: "", rating: "5", score: 1 },
      { description: "", rating: "5", score: 1 },
    ]);
  };

  const saveManageTemplateUpdate = async () => {
    if (!selectedStaff?.staff_id || !selectedRole?.role_id || !evaluationType) {
      alert("Please select staff, role, and evaluation type.");
      return;
    }

    const cleanedFactors = factors.filter(
      (item) => item.factor?.trim() || item.description?.trim(),
    );

    const cleanedPerformances = performances.filter(
      (item) => item.description?.trim(),
    );

    const newFactors = cleanedFactors
      .filter((item) => !item.id && !item.manage_id)
      .map((item) => ({
        factor: item.factor,
        description: item.description,
        rating: item.rating || "5",
      }));

    const updatedFactors = cleanedFactors
      .filter((item) => item.id || item.manage_id)
      .map((item) => ({
        id: item.id || item.manage_id,
        factor: item.factor,
        description: item.description,
        rating: item.rating || "5",
      }));

    const newPerformances = cleanedPerformances
      .filter((item) => !item.id && !item.manage_id)
      .map((item) => ({
        description: item.description,
        rating: item.rating || "5",
        score: item.score === undefined || item.score === null ? 1 : item.score,
      }));

    const updatedPerformances = cleanedPerformances
      .filter((item) => item.id || item.manage_id)
      .map((item) => ({
        id: item.id || item.manage_id,
        description: item.description,
        rating: item.rating || "5",
        score: item.score === undefined || item.score === null ? 1 : item.score,
      }));

    try {
      setSaving(true);
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      console.log("Saving manage appraisal update:", {
        newFactors,
        updatedFactors,
        newPerformances,
        updatedPerformances,
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API}/manageAppraisalTemplateUpdate`,
        {
          staff_id: selectedStaff.staff_id,
          role_id: selectedRole.role_id,
          type: evaluationType,
          unique_doc_id: editingTemplate?.unique_doc_id || null,
          newFactors,
          updatedFactors,
          newPerformances,
          updatedPerformances,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        alert("Template updated successfully!");
        resetForm();
        await fetchTemplate();
      } else {
        alert(response.data.message || "Failed to update template.");
      }
    } catch (error) {
      console.error("Error updating manage appraisal template:", error);
      alert(
        error.response?.data?.message ||
          "Server error. Please try again later.",
      );
    } finally {
      setSaving(false);
    }
  };

  const saveAppraisal = async () => {
    if (editMode) {
      await saveManageTemplateUpdate();
      return;
    }

    if (factors.length === 0) {
      alert("Please add at least one factor and one performance.");
      return;
    }

    if (!selectedStaff?.staff_id || !selectedRole?.role_id || !evaluationType) {
      alert("Please select staff, role, and evaluation type.");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API}/manageAppraisal`,
        {
          staff_id: selectedStaff.staff_id,
          role_id: selectedRole.role_id,
          type: evaluationType,
          factors,
          performances,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        alert("Performance Appraisal saved successfully!");

        resetForm();
      } else {
        alert("Failed to save appraisal. Please try again.");
      }
    } catch (error) {
      console.error("Error saving appraisal:", error);
      alert("Server error. Please try again later.");
    }
  };

  const fetchTemplate = async () => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API}/getAssessment`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        setTemplate(response.data.data);
      } else {
        console.error("Error fetching the Template:", response.data.message);
      }
    } catch (err) {
      console.error("Failed to fetch Template", err);
    }
  };

  const handleClose = () => setShowModal(false);

  const handleShow = async () => {
    await fetchTemplate();
    setShowModal(true);
  };

  const handleEdit = (item) => {
    // console.log("View/Edit clicked for:", item);
    navigate(`/view-staffappraisal/${item.role_id}/${item.staff_id}`);
  };

  const handleEditTemplate = async (item) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API}/getDetailAppraisal`,
        {
          params: {
            staff_id: item.staff_id,
            role_id: item.role_id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.data.success) {
        alert(response.data.message || "Failed to load template.");
        return;
      }

      const rows = response.data.data || [];

      const uniqueRows = Array.from(
        new Map(
          rows
            .filter((row) => row.manage_id)
            .map((row) => [String(row.manage_id), row])
        ).values()
      );

      const selectedStaffRow =
        staff.find((s) => String(s.staff_id) === String(item.staff_id)) ||
        {
          staff_id: item.staff_id,
          display_name: item.display_name,
        };

      const selectedRoleRow =
        roles.find((r) => String(r.role_id) === String(item.role_id)) ||
        {
          role_id: item.role_id,
          roles: item.roles || item.role || "Selected form",
        };

      const factorRows = uniqueRows.filter(
        (row) => String(row.part_number) === "1",
      );
      const performanceRows = uniqueRows.filter(
        (row) => String(row.part_number) === "2",
      );

      setSelectedStaff(selectedStaffRow);
      setSelectedValue(selectedStaffRow.display_name || item.display_name);
      setSelectedRole(selectedRoleRow);
      setEvaluationType(item.type || "appraisal");
      setEditingTemplate(item);
      setEditMode(true);

      setFactors(
        factorRows.length > 0
          ? factorRows.map((row) => ({
              id: row.manage_id,
              factor: row.factor || "",
              description: row.description || "",
              rating: row.default_rating_scale || "5",
            }))
          : [{ factor: "", description: "", rating: "5" }],
      );

      setPerformances(
        performanceRows.length > 0
          ? performanceRows.map((row) => ({
              id: row.manage_id,
              description: row.description || "",
              rating: row.default_rating_scale || "5",
              score: row.weight === null || row.weight === undefined ? 1 : row.weight,
            }))
          : [{ description: "", rating: "5", score: 1 }],
      );

      setStep(1);
      setShowModal(false);
    } catch (error) {
      console.error("Error loading manage appraisal template:", error);
      alert(
        error.response?.data?.message ||
          "Server error. Please try again later.",
      );
    }
  };

  const handleDelete = async (item) => {
    if (
      !window.confirm(
        `Are you sure you want to delete this form for ${item.display_name}?`,
      )
    ) {
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${process.env.REACT_APP_API}/deleteAppraisalForm`,
        { id: item.staff_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        alert("Appraisal form deleted successfully.");
        setShowModal(false);
      } else {
        alert(response.data.message || "Failed to delete the appraisal form.");
      }
    } catch (error) {
      console.error("Error deleting appraisal form:", error);
      alert("An error occurred while deleting the appraisal form.");
    }
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const userDescription = user?.description || "";

  if (userDescription !== "HR" && userDescription !== "MIS") {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <h1>Unauthorized</h1>
        <p>You do not have permission to view this page.</p>
      </div>
    );
  }

  return (
    <>
      <NavMenu />
      <div className={`p-4 ${isDark ? "text-light" : "text-dark"}`}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="header-title mb-0 fw-bold">
            {editMode ? "Edit PA Assessment Template" : "Form Creation"}
          </h5>

          <div className="d-flex align-items-center">
            <Button
              variant="outline-light"
              style={{ background: "#B31E8D" }}
              onClick={handleShow}
            >
              Review PA forms
            </Button>{" "}
            &nbsp;
            {editMode && (
              <>
                &nbsp;
                <Button
                  variant="outline-secondary"
                  onClick={resetForm}
                  disabled={saving}
                >
                  Cancel Edit
                </Button>
              </>
            )}
            &nbsp;
            <Button
              variant="outline-light"
              style={{ border: "2px solid #B31E8D", color: "#B31E8D" }}
              onClick={() => navigate("/appraisal-management")}
            >
              Create Template
            </Button>
          </div>
        </div>

        <div className="d-flex align-items-center mb-3  gap-3">
          <label className="me-2 mb-0 fw-bold" style={{ width: "100px" }}>
            Form:
          </label>

          <DropdownButton
            title={selectedRole?.roles || "Select form"}
            onSelect={handleSelectRole}
            variant={isDark ? "dark" : "outline-dark"}
            className={isDark ? "dropdown-dark" : ""}
          >
            {roles.length > 0 ? (
              roles.map((role) => (
                <Dropdown.Item
                  key={role.role_id}
                  eventKey={role.role_id}
                  className={isDark ? "bg-dark text-light" : ""}
                >
                  {role.roles}
                </Dropdown.Item>
              ))
            ) : (
              <Dropdown.Item
                disabled
                className={isDark ? "bg-dark text-light" : ""}
              >
                No Form available
              </Dropdown.Item>
            )}
          </DropdownButton>

          <div className="form-check ms-3">
            <input
              className="form-check-input"
              type="radio"
              name="evaluationType"
              id="appraisalRadio"
              value="appraisal"
              checked={evaluationType === "appraisal"}
              onChange={(e) => setEvaluationType(e.target.value)}
            />
            <label className="form-check-label" htmlFor="appraisalRadio">
              Appraisal
            </label>
          </div>

          <div className="form-check ms-3">
            <input
              className="form-check-input"
              type="radio"
              name="evaluationType"
              id="confirmationRadio"
              value="confirmation"
              checked={evaluationType === "confirmation"}
              onChange={(e) => setEvaluationType(e.target.value)}
            />
            <label className="form-check-label" htmlFor="confirmationRadio">
              Confirmation
            </label>
          </div>
        </div>

        <div className="d-flex align-items-center mb-3">
          <label className="me-2 mb-0 fw-bold" style={{ width: "110px" }}>
            Staff name:
          </label>

          <Dropdown
            show={showStaffDropdown}
            onToggle={() => setShowStaffDropdown(!showStaffDropdown)}
          >
            <Dropdown.Toggle variant={isDark ? "dark" : "outline-dark"}>
              {selectedValue}
            </Dropdown.Toggle>

            <Dropdown.Menu
              className={isDark ? "dropdown-dark" : ""}
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                backgroundColor: isDark ? "#2c2c2c" : "#fff",
                color: isDark ? "#fff" : "#000",
              }}
            >
              <div className="px-3 py-2">
                <FormControl
                  placeholder="Search staff..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  autoFocus
                  className={
                    isDark ? "bg-dark text-light border-secondary" : ""
                  }
                  style={{ fontSize: "14px" }}
                />
              </div>
              <Dropdown.Divider />
              {filteredStaff.length > 0 ? (
                filteredStaff.map((item) => (
                  <Dropdown.Item
                    key={item.staff_id}
                    eventKey={String(item.staff_id)}
                    onClick={() => handleSelectStaff(String(item.staff_id))}
                    className={isDark ? "text-light" : ""}
                  >
                    {item.display_name}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled className={isDark ? "text-light" : ""}>
                  No matching names
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="stepper mb-4 d-flex align-items-center gap-2">
          {[1, 2].map((num) => (
            <React.Fragment key={num}>
              <div
                className={`step ${step === num ? "active" : ""} ${
                  isDark ? "step-dark" : "step-light"
                }`}
                onClick={() => setStep(num)}
                style={{ cursor: "pointer" }}
              >
                {num}
              </div>
              {num < 2 && (
                <div
                  className={`line ${isDark ? "line-dark" : "line-light"}`}
                />
              )}
            </React.Fragment>
          ))}
        </div>

        {step === 1 && (
          <>
            <p className="fw-semibold">Part I: COMPETENCIES</p>
            <Row>
              <Col md={3}>
                <p>Factor</p>
              </Col>
              <Col md={8}>
                <p>Description</p>
              </Col>
              <Col md={1}>
                <p>Action</p>
              </Col>
              {/* <Col md={3}>
                <p>Rating</p>
              </Col> */}
            </Row>
            {factors.map((factor, idx) => (
              <Row key={idx} className="mb-3">
                <Col md={3}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder={`Factor #${idx + 1}`}
                    value={factor.factor}
                    onChange={(e) =>
                      handleFactorChange(idx, "factor", e.target.value)
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                  />
                </Col>
                <Col md={8}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder="Description"
                    value={factor.description}
                    onChange={(e) =>
                      handleFactorChange(idx, "description", e.target.value)
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                  />
                </Col>
                <Col md={1} className="d-flex align-items-start justify-content-center">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDeleteFactorRow(idx)}
                    disabled={saving || deletingItemId === (factor.id || factor.manage_id)}
                    title="Delete factor"
                  >
                    <MdDeleteForever size={18} />
                  </Button>
                </Col>
                {/* <Col md={3}>
                  <Form.Select
                    value={factor.rating}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handleFactorChange(idx, "rating", e.target.value)
                    }
                  >
                    <option>Rating</option>
                    <option>5</option>
                    <option>4</option>
                  </Form.Select>
                </Col> */}
              </Row>
            ))}
            <div className="d-flex justify-content-between align-items-center mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={addFactor}
              >
                Add Factor
              </Button>

              <div className="d-flex gap-3">
                <Button
                  variant="outline-light"
                  onClick={() => setStep(2)}
                  style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
                >
                  Next Page
                </Button>
              </div>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <p className="fw-semibold">
              Part II: SPECIFIC PERFORMANCE OBJECTIVES
            </p>
            <Row>
              <Col md={11}>
                <p>Description of Work Targets and Actual Results Attained</p>
              </Col>
              <Col md={1}>
                <p>Action</p>
              </Col>

              {/* <Col md={3}>
                <p>Rating</p>
              </Col> */}
            </Row>
            {performances.map((perf, idx) => (
              <Row key={idx} className="mb-3">
                <Col md={11}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder="Key Objectives"
                    value={perf.description}
                    onChange={(e) =>
                      handlePerformanceChange(
                        idx,
                        "description",
                        e.target.value,
                      )
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                  />
                </Col>
                <Col md={1} className="d-flex align-items-start justify-content-center">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDeletePerformanceRow(idx)}
                    disabled={saving || deletingItemId === (perf.id || perf.manage_id)}
                    title="Delete objective"
                  >
                    <MdDeleteForever size={18} />
                  </Button>
                </Col>

                {/* <Col md={3}>
                  <Form.Select
                    value={perf.rating}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handlePerformanceChange(idx, "rating", e.target.value)
                    }
                  >
                    <option>Rating</option>
                    <option>5</option>
                    <option>4</option>
                  </Form.Select>
                </Col> */}
              </Row>
            ))}
            <div className="d-flex justify-content-between align-items-center mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={addPerformance}
              >
                Add New Key Objectives
              </Button>

              <div className="d-flex gap-3">
                <Button
                  variant="outline-light"
                  onClick={() => setStep(1)}
                  style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
                >
                  Back
                </Button>
                <Button
                  variant="outline-light"
                  size="sm"
                  style={{
                    background: "#B31E8D",
                  }}
                  onClick={saveAppraisal}
                  disabled={saving}
                >
                  {saving
                    ? "Saving..."
                    : editMode
                      ? "Update PA Assessment"
                      : "Save PA Assessment"}
                </Button>
              </div>
            </div>
          </>
        )}

        {/* {step === 3 && (
          <>
            <p className="fw-semibold">Part III: OVERALL ASSESSMENT</p>
            <p className="fw-semibold">Summary of Ratings</p>
            <p>Overall Rating For Part I & Part II</p>

            <Row className="mb-4">
              <Col md={3}>
                {[
                  "EXCELLENT",
                  "VERY GOOD",
                  "GOOD",
                  "SATISFACTORY",
                  "BELOW AVERAGE",
                  "POOR",
                ].map((label, i) => (
                  <p key={i} className="fw-semibold">
                    {label}
                  </p>
                ))}
              </Col>
              <Col md={2}>
                {[
                  "4.5 to 5.0",
                  "4.0 to 4.49",
                  "3.5 to 3.99",
                  "3.0 to 3.49",
                  "2.5 to 2.99",
                  "< 2.5",
                ].map((score, i) => (
                  <p key={i} className="fw-semibold">
                    {score}
                  </p>
                ))}
              </Col>
              <Col md={7}>
                <p className="text-secondary small">
                  Excellent performance, well exceeded expectations. For
                  recruiters who exceed 120% of quota.
                </p>
                <p className="text-secondary small">
                  Very good performance and consistently exceed expectations.
                  For recruiters who exceed 100% -119% of quota.
                </p>
                <p className="text-secondary small">
                  Good performance and exceed expectations in many areas. For
                  recruiters who exceed 85% - 100% of quota.
                </p>
                <p className="text-secondary small">
                  Satisfactory performance, meet basic expectations and need
                  some supervision. For recruiters who achieved between 70-84%
                  of quota.
                </p>
                <p className="text-secondary small">
                  Below average performance. Needs supervision in their work.
                  Warrant P-I-P if performance remains below average for 2
                  consecutive quarters. Recruiters who meet 50% - 69% of quota.
                </p>
                <p className="text-secondary small">
                  Poor performance. Need improvement and a lot of supervision in
                  all work areas. Warrant P-I-P. Recruiters who achieved less
                  than 50% of quota for more than 2 consecutive quarters.
                </p>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{
                  background: "#B31E8D",
                  width: "200px",
                  height: "50px",
                }}
                onClick={saveAppraisal}
              >
                Save PA Assessment
              </Button>
            </div>
          </>
        )} */}
      </div>
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header
          closeButton
          className={isDark ? "bg-dark text-light" : ""}
        >
          <Modal.Title>View Form</Modal.Title>
        </Modal.Header>

        <Modal.Body className={isDark ? "bg-dark text-light" : ""}>
          <table
            className={`table table-bordered text-center ${
              isDark ? "table-dark" : ""
            }`}
          >
            <thead
              className={
                isDark ? "bg-secondary text-light" : "table-light text-center"
              }
            >
              <tr>
                <th style={{ width: "5%" }}>No</th>
                <th style={{ width: "30%" }}>Employee Name</th>
                <th style={{ width: "15%" }}>Type</th>
                <th style={{ width: "15%" }}>Created Date</th>
                <th style={{ width: "25%" }}>Action</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {paginatedData && paginatedData.length > 0 ? (
                Object.entries(
                  paginatedData.reduce((groups, item) => {
                    const dept = item.department || "No Department";
                    if (!groups[dept])
                      groups[dept] = {
                        items: [],
                        total: item.total_count || 0,
                      };
                    groups[dept].items.push(item);
                    return groups;
                  }, {}),
                ).map(([dept, data], deptIndex) => {
                  const currentCount = data.items.length;
                  const remaining = (data.total ?? 0) - currentCount;

                  return (
                    <React.Fragment key={deptIndex}>
                      <tr
                        style={{
                          backgroundColor: isDark ? "#555" : "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td colSpan="4" style={{ textAlign: "left" }}>
                          {dept}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <span
                            className={`badge rounded-pill ${
                              isDark
                                ? "bg-secondary text-dark"
                                : "bg-dark text-light"
                            }`}
                          >
                            Remaining: {remaining >= 0 ? remaining : 0}
                          </span>
                        </td>
                      </tr>

                      {data.items.map((item, index) => (
                        <tr key={item.id || `${deptIndex}-${index}`}>
                          <td>{index + 1}</td>
                          <td>{item.display_name}</td>
                          <td>{item.type}</td>
                          <td>
                            {item.created_at && item.created_at !== "0000-00-00"
                              ? moment(item.created_at).format("DD-MM-YYYY")
                              : ""}
                          </td>
                          <td>
                            <div className="d-flex justify-content-center gap-2">
                              <Button
                                size="sm"
                                style={{
                                  backgroundColor: "#198754",
                                  border: "none",
                                  color: "white",
                                }}
                                onClick={() => handleEditTemplate(item)}
                              >
                                Edit Template
                              </Button>
                              <Button
                                size="sm"
                                style={{
                                  backgroundColor: "#B31E8D",
                                  border: "none",
                                  color: "white",
                                }}
                                onClick={() => handleEdit(item)}
                              >
                                View Appraisal
                              </Button>
                              <Button
                                size="sm"
                                style={{
                                  backgroundColor: "#B31E8D",
                                  border: "none",
                                  color: "white",
                                }}
                                onClick={() => handleDelete(item)}
                              >
                                <MdDeleteForever size={20} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">No templates available.</td>
                </tr>
              )}
            </tbody>
          </table>

          {totalPages > 1 && (
            <Pagination className="justify-content-center">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {[...Array(totalPages)].map((_, idx) => (
                <Pagination.Item
                  key={idx + 1}
                  active={idx + 1 === currentPage}
                  onClick={() => handlePageChange(idx + 1)}
                >
                  {idx + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          )}
        </Modal.Body>

        <Modal.Footer
          className={`d-flex justify-content-between align-items-center ${
            isDark ? "bg-dark text-light" : ""
          }`}
        >
          <small className="text-muted">
            Use Edit Template to update the current form without deleting it
          </small>

          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AppraisalAssessment;
